import { configureStore, combineReducers } from "@reduxjs/toolkit";
import localRedux from 'redux-persist/lib/storage'; // localStorage
import { FLUSH, PAUSE, PURGE, PERSIST, REGISTER, REHYDRATE, persistStore, persistReducer } from "redux-persist";

import userReducer from "./reducers/user";
import appSlice from "./reducers/appSlice";
import eventReducer from "./reducers/eventSlice";
import socketReducer from "./reducers/socketSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage: localRedux,
  whitelist: ["user"],
};

const appPersistConfig = {
  key: 'app',
  storage: localRedux,
  whitelist: ['artifacts'],
};


const combinedReducer = combineReducers({
  user: userReducer,
  app: persistReducer(appPersistConfig, appSlice),
  event: eventReducer,
  socket: socketReducer,
});

const persistedReducer = persistReducer(persistConfig, combinedReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

// Infer the `RootState` type from the root reducer
export type RootState = ReturnType<typeof combinedReducer>;

// Infer the type of `store`
export type AppStore = typeof store;

// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore["dispatch"];
